import {
    SUCCESS_GET_TICKETS,
    FAILED_GET_TICKETS,
    SUCCESS_IS_CONNECTED,
    FAILED_IS_CONNECTED,
    SUCCESS_CREATE_TICKET,
    FAILED_CREATE_TICKET,
    SUCCESS_ADD_COMMENT,
    FAILED_ADD_COMMENT,
    SUCCESS_GET_CLIENT_NOTIFY_HISTORIES,
    FAILED_GET_CLIENT_NOTIFY_HISTORIES,
    GET_OPENED_TICKET_COUNT_SUCCESS,
    GET_OPENED_TICKET_COUNT_FAILED,
    GET_NOTIFICATION_COUNT_SUCCESS,
    GET_NOTIFICATION_COUNT_FAILED,
    GET_NOTIFICATIONS_SUCCESS,
    GET_NOTIFICATIONS_FAILED,
    MARK_NOTIFICATION_AS_READ_SUCCESS,
    MARK_NOTIFICATION_AS_READ_FAILED,
    MARK_ALL_NOTIFICATIONS_AS_READ_SUCCESS,
    MARK_ALL_NOTIFICATIONS_AS_READ_FAILED,
    CLEAR_ALL_READ_NOTIFICATIONS_SUCCESS,
    CLEAR_ALL_READ_NOTIFICATIONS_FAILED,
    OPEN_NOTIFICATIONS_SLIDER,
    CLOSE_NOTIFICATIONS_SLIDER,
    REMOVE_TICKET_CC_SUCCESS,
    REMOVE_TICKET_CC_FAILED,
} from '../constants/zendeskConstants';

export function successIsConnected(data) {
    return {
        type: SUCCESS_IS_CONNECTED,
        payload: data,
    };
}

export function failedIsConnected(error) {
    const errorData = error.response && error.response.data ? error.response.data : error.message;
    return {
        type: FAILED_IS_CONNECTED,
        errorMessage: 'Error fetching tickets from Zendesk: ' + JSON.stringify(errorData),
    };
}

export function successGetTickets(data) {
    return {
        type: SUCCESS_GET_TICKETS,
        payload: data,
    };
}

export function failedGetTickets(error) {
    const errorData = error.response && error.response.data ? error.response.data : error.message;
    return {
        type: FAILED_GET_TICKETS,
        errorMessage: 'Error fetching tickets from Zendesk: ' + JSON.stringify(errorData),
    };
}

export const successCreateTicket = (data) => ({
    type: SUCCESS_CREATE_TICKET,
    payload: data,
});

export const failedCreateTicket = (error) => ({
    type: FAILED_CREATE_TICKET,
    payload: error,
});

export const successAddComment = (data) => ({
    type: SUCCESS_ADD_COMMENT,
    payload: data,
});

export const failedAddComment = (error) => ({
    type: FAILED_ADD_COMMENT,
    payload: error,
});

export const successGetClientNotifyHistories = (payload) => ({
    type: SUCCESS_GET_CLIENT_NOTIFY_HISTORIES,
    payload: payload,
});

export const failedGetClientNotifyHistories = (error) => ({
    type: FAILED_GET_CLIENT_NOTIFY_HISTORIES,
    payload: error,
});

export const successGetOpenedTicketCount = data => ({
    type: GET_OPENED_TICKET_COUNT_SUCCESS,
    payload: data,
});

export const failedGetOpenedTicketCount = error => ({
    type: GET_OPENED_TICKET_COUNT_FAILED,
    payload: error,
});

export const successGetNotificationCount = data => ({
    type: GET_NOTIFICATION_COUNT_SUCCESS,
    payload: data,
});

export const failedGetNotificationCount = error => ({
    type: GET_NOTIFICATION_COUNT_FAILED,
    payload: error,
});

export const successGetNotifications = data => ({
    type: GET_NOTIFICATIONS_SUCCESS,
    payload: data,
});

export const failedGetNotifications = error => ({
    type: GET_NOTIFICATIONS_FAILED,
    payload: error,
});

export const successMarkNotificationAsRead = (data) => ({
    type: MARK_NOTIFICATION_AS_READ_SUCCESS,
    payload: data,
});

export const failedMarkNotificationAsRead = (error) => ({
    type: MARK_NOTIFICATION_AS_READ_FAILED,
    payload: error,
});

export const successMarkAllNotificationsAsRead = (data) => ({
    type: MARK_ALL_NOTIFICATIONS_AS_READ_SUCCESS,
    payload: data,
});

export const failedMarkAllNotificationsAsRead = (error) => ({
    type: MARK_ALL_NOTIFICATIONS_AS_READ_FAILED,
    payload: error,
});

export const successClearAllReadNotifications = (data) => ({
    type: CLEAR_ALL_READ_NOTIFICATIONS_SUCCESS,
    payload: data,
});

export const failedClearAllReadNotifications = (error) => ({
    type: CLEAR_ALL_READ_NOTIFICATIONS_FAILED,
    payload: error,
});

export const openNotificationsSlider = () => ({
    type: OPEN_NOTIFICATIONS_SLIDER,
});

export const closeNotificationsSlider = () => ({
    type: CLOSE_NOTIFICATIONS_SLIDER,
});

export const successRemoveTicketCc = data => ({
    type: REMOVE_TICKET_CC_SUCCESS,
    payload: data,
});

export const failedRemoveTicketCc = error => ({
    type: REMOVE_TICKET_CC_FAILED,
    payload: error,
});



// WEBPACK FOOTER //
// src/state/actions/zendeskActions.js